module.exports = __webpack_public_path__ + "img/dianxin5-1.cb316e4a.jpg";